/**
 * İş Bankası Maximum — Kredi Kartı BIN listesi.
 * Merchant sözleşmesi sadece Maximum markalı kredi kartlarını taksit için kapsıyor.
 * Banka kartları (debit, Maxipara, prepaid, Maestro vb.) ve non-Maximum kartlar hariç.
 *
 * Kaynak: BIN Listesi - T. İş Bankası.xls (2026-04)
 * Filter: Maximum=Evet AND Kart Tipi=Kredi Kartı AND Geçerli Kayıt=Evet
 *
 * Not: 8 haneli sub-BIN'ler ilk sırada — uzun prefix kısa prefix'ten önce eşleşsin.
 */
const IS_BANKASI_MAXIMUM_CREDIT_BINS: ReadonlyArray<string> = [
  // 8-digit sub-BINs
  '45435901', // PLATINIUM (VISA)
  '55209621', // MC MMBLACK (MASTERCARD)
  // 6-digit BINs
  '418342',   // SANALKART-NORMAL (VISA)
  '418343',   // PATI KART (VISA)
  '438331',   // TICARI SANAL KART (VISA)
  '450803',   // BUSINESS (VISA)
  '454318',   // KLASIK (VISA)
  '454358',   // PREMIER (VISA)
  '454359',   // PREMIER (VISA)
  '454360',   // NORMAL (VISA)
  '473998',   // TICARI SANAL KART (VISA)
  '474138',   // NORMAL (VISA)
  '474301',   // PREMIER (VISA)
  '474308',   // KLASIK HCE (VISA)
  '474340',   // PREMIER (VISA)
  '474508',   // KLASIK HCE (VISA)
  '479610',   // KLASIK HCE (VISA)
  '510152',   // SANALKART (MASTERCARD)
  '525382',   // GENÇLIK KART (MASTERCARD)
  '540667',   // NORMAL (MASTERCARD)
  '540668',   // PREMIER (MASTERCARD)
  '543709',   // NORMAL (MASTERCARD)
  '543771',   // NORMAL (MASTERCARD)
  '548237',   // GOLD HCE (MASTERCARD)
  '548615',   // MC MAXIMUM (MASTERCARD)
  '552096',   // PLATINIUM (MASTERCARD)
  '553058',   // BUSINESS (MASTERCARD)
  '559289',   // TICARI SANAL KART2 (MASTERCARD)
  '600652',   // PRIVATE (MASTERCARD)
  '650173',   // TROY CREDIT (TROY)
  '650987',   // TROY TICARI CREDIT (TROY)
  '650990',   // TICARI SANAL KART3 (TROY)
  '979204',   // TROY CREDIT (TROY)
];

/**
 * Kart numarasının İş Bankası Maximum kredi kartı olup olmadığını kontrol eder.
 * Boşluklar otomatik temizlenir. İlk 8 haneye kadar prefix karşılaştırması yapar.
 */
export function isIsBankasiMaximum(cardNumber: string | null | undefined): boolean {
  if (!cardNumber) return false;
  const digits = cardNumber.replace(/\D/g, '');
  if (digits.length < 6) return false;
  return IS_BANKASI_MAXIMUM_CREDIT_BINS.some((prefix) => digits.startsWith(prefix));
}
